import _ from 'underscore';
import Handlebars from 'handlebars';
import ApiKeyUsersView from 'js/views/apiKeys.generic.view';
import GenericView from 'js/views/generic.view';
import PaginatedView from 'js/views/pagination.view';
import Template from 'js/templates/woo.users.hbs';

import i18n from 'l10n';
import dhtmlx from 'dhtmlxAdapter';
import {debounce, el, model, on, tagName, template} from "../adapters/backbone-decorators";
import QRCode from "qrcode";

@el("#woo-shops")
//@model(ApiKeyUsersModel)
@tagName("div")
@template(Template)
class ShopsView extends ApiKeyUsersView {

    constructor(options) {
        super(options);

        this.collection.url = `${this.collectionUrl}/${this.userRole}`;

        // render the collection only on the first time
        this.renderCollection();
    }

    // @Override
    get userRole() {
        return 'Woo';
    }

    // @Override
    get className() {
        return '';
    }

    render() {

        this.renderPagination(this.pagination, this.collection, '#pagination');
        this.showHideNoFoundRedeemers(this.collection.count);

        return this;
    }

    renderPagination(pagination, collection, elem) {
        if (pagination) {
            pagination.remove();
        }

        pagination = new PaginatedView({collection: collection});
        pagination.render();
        // Replace view's pagination
        this.$(elem).html(pagination.$el);
    }

    async renderCollection() {
        const response = await this.collection.getFirstPage();
        $(this.el).html(this.template({users: response.data, count: response.count, searchTerm: this.searchText}));
        this.render();
        if (this.searchText) {
            var $usersSearchBox = this.$('.usersSearchBox');
            $usersSearchBox.val(this.searchText);
            $usersSearchBox.focus();
        }
        this.$el.find('#email').on("input", event => this.emailOnEdit(event));

    }

    @on('click .submitNewUserInfo')
    async submitUserInfo() {
        var domain = this.$(".domain").val();
        if (!domain || $.trim(domain).length === 0) {
            dhtmlx.alert(i18n.t("engagement.fieldMustNotBeEmpty"));
        } else {
            try {
                const url = new URL(domain.startsWith("http") ? domain : `http://${domain}`);
                this.toggleNewUserButton(true);
                const postData = {description: url.host};

                await this.createUser(postData);
            } catch (e) {
                dhtmlx.alert(i18n.t("generic.enterValidDomain"));
            }
        }

    }
}

export default ShopsView;
